"use client";

/* 跨站点确认弹窗组件 */
// React
import React from "react";
// 三方库
import { useTranslation } from "@/i18n/client";
//公共方法
import { userSwitchCountry } from "@/utils/multiSite";
// 组件
import { Button, DialogContent, DialogActions, Typography } from "@mui/material";
import UKDialog from "@/components/UKDialog";

interface SiteChangeConfirmDialogProps {
  open: boolean;
  toCountryCode: string;
  toCountryName: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  setDialogOpen: (open: boolean) => void;
}

/**
 * 跨站点确认弹窗组件
 * 用于用户选择切换到其他国家/站点时的确认提示
 */
const SiteChangeConfirmDialog: React.FC<SiteChangeConfirmDialogProps> = ({
  open,
  toCountryCode,
  toCountryName,
  onConfirm,
  onCancel,
  setDialogOpen
}) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    userSwitchCountry(toCountryCode);
    onConfirm?.();
    setDialogOpen(false);
  };

  const handleCancel = () => {
    onCancel?.();
    setDialogOpen(false);
  };

  return (
    <UKDialog
      open={open}
      onClose={handleCancel}
      showCloseBtn={true}
    >
      <DialogContent>
        <Typography variant="body1">
          {t("address.siteChange.updateLocation", { countryName: toCountryName })}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {t("address.siteChange.impactNotice")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>
          {t("address.cancel")}
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          {t("address.confirm")}
        </Button>
      </DialogActions>
    </UKDialog>
  );
};

export default SiteChangeConfirmDialog;
